import { render, staticRenderFns } from "./ExpandForm.vue?vue&type=template&id=79b46a54&"
import script from "./ExpandForm.vue?vue&type=script&lang=js&"
export * from "./ExpandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports